<template>
    <div>
        <s-modal
            :open="open"
            @close="$emit('close')"
            :close="true"
        >
            <div style="text-align:center;margin: 20px">
            <apexchart  type="line" :options="chartOptions" :series="series"></apexchart>
            </div>
        </s-modal>
    </div>
</template>
<script>
import firebase_api from "@/firebase/firebase_api"
import apexchart from 'vue-apexcharts'
export default {
    props:['open','joueur', 'club'],
    components: {
        apexchart
    },
    watch: {
        open() {
            this.tournois = [];
            this.refresh();
        }
    },
    data() {
        return {
            tournois:[],
            series: [{
                        name: "",
                        data: [],
                        type: 'line'
                    },
                    {
                        name: "",
                        data: [],
                        type: 'bar',
                        stacked: true,
                        border: 0,
                        
                    },
                    {
                        name: "",
                        data: [],
                        type: 'bar',
                        border: 0,
                        stacked: true,
                        fill: {
                            colors: ['#02DFDE','#02DFDE'],
                            type: 'solid'
                        }
                    }],
           
            initChart: {
                
            },
            chartOptions: {
                
                plotOptions: {
                    bar: {
                    columnWidth: "20%",
                    border: 0,
                    }
                },
                
                chart: {
                height: 400,
                width: "100%",
                type: 'bar',
                stacked: true,
                zoom: {
                    enabled: false
                },
                
                },
                dataLabels: {
                enabled: false,
                formatter: function (val) {
                    return val +"€";
                    }
                },
                stroke: {
                curve: 'straight'
                },
                title: {
                text: 'Classement',
                align: 'left'
                },
                grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
                },
                xaxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
                    labels :{
                        rotate: -45,
                        rotateAlways: true
                    }
                },
                 yaxis: 
                     [{
                        seriesName: "Classement",
                         reversed: true
                      }
                     ,
                     {
                         seriesName : "Parties Gagnées",
                         opposite: true,
                          floating: false,
                           forceNiceScale: true,
                      }
                     ]
            
            }
            }
        
    },
    methods: {
        formatDate(date) {
            var options = {year: "numeric", month: "numeric", day: "numeric"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
        refresh() {
            if (typeof(this.joueur)!="undefined" && typeof(this.club)!="undefined") {
                
                if (typeof(this.joueur.id)!="undefined") {
                this.initChart = JSON.parse(JSON.stringify(this.chartOptions));
               
                var clubRef = firebase_api.api.getDb().collection('club').doc(this.joueur.idClub);
                clubRef.get().then(clubDoc=>{
                    
                    this.initChart.yaxis[0].max = clubDoc.data().nbJoueurs;
                    this.initChart.yaxis[0].min = 1;
                    this.initChart.yaxis[1].max = 3;
                    this.initChart.yaxis[1].min = 0;
                })    
                var today = new Date();
                var year = today.getFullYear() - 1;
                var searchDate = new Date(year, today.getMonth(), 1);
                clubRef.collection('joueurs').doc(this.joueur.id)
                    .collection('tournois').where('date','>=',searchDate.getTime()).orderBy('date').get().then(snapshot=>{
                    
                        snapshot.docs.forEach((element, indiceElement) => {
                            this.tournois.push(element.data());
                        
                            if (indiceElement == snapshot.docs.length-1) {
                                
                                
                                var index = 0;
                                this.series[0].data = [];
                                this.series[0].name = "Classement";
                                
                                this.initChart.xaxis.categories = [];
                                this.series[1].data = [];
                                this.series[2].data = [];
                                this.series[1].name = "Parties Gagnées";
                                this.series[2].name = "Parties Perdues";
                                this.tournois.forEach(tournoi=>{
                                    var rang = parseInt(tournoi.rang);
                                
                                    this.series[0].data.push(rang);
                                    this.series[1].data.push(tournoi.nbGagnes);
                                    var nbPartiePerdues = tournoi.nbParties - tournoi.nbGagnes;
                                    this.series[2].data.push(nbPartiePerdues);
                                    var date = this.formatDate(tournoi.date);
                                    this.initChart.xaxis.categories.push(date);
                                    index++;
                                    if (index == this.tournois.length-1)
                                        this.chartOptions = this.initChart;
                                })
                                
                                }
                        });
                    })
                }
            }
        }
    },
    mounted() {

    }
}
</script>